/* eslint-disable camelcase */
import React from 'react'
import Money from './Money'

interface PriceProps {
  product: { total_discount: number, price: number, final_price: number, price_varies?: boolean, min_price?: number },
  cart?: boolean
}

const PriceDisplay = (props: PriceProps = {product: null, cart: false}) : JSX.Element => {
  return (
    <p className="product-price">
      { props.product.price_varies && props.product.min_price ?
        (
          <>
            <span>From</span><span data-ge-price><Money withCurrency amount={props.product.min_price} ></Money></span>
          </>)
        : (
          <>
            { props.product.total_discount > 0 && <s {...props.cart ? { 'data-ge-basket-productlistprice': true } : {'data-ge-price': true}}><Money withCurrency amount={props.product.price} /></s>}
            <span {...props.cart ? { 'data-ge-basket-productsaleprice': true } : {'data-ge-price': true}}>
              <Money withCurrency amount={props.product.final_price} />
            </span>
          </>
        )
      }
    </p>
  )
}


export default PriceDisplay